<template>
  <div class="col-2">
    <div class="mb-3 thumbnail cursor-pointer bg-white" @click="selectFile(file)">
      <img
        :src="'https://storage.googleapis.com/amchara-205620.appspot.com/storage/' + file"
        style="height:100%; width: 100%"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ["file"],
  methods: {
    selectFile(file) {
      this.$emit("selected", {
        url:
          "https://storage.googleapis.com/amchara-205620.appspot.com/storage/" +
          file
      });
    }
  }
};
</script>

<style>
.thumbnail {
  width: 100% !important;
  height: 50px !important;
}
.thumbnail:hover {
  position: absolute !important;
  width: 500px !important;
  height: auto !important;
  display: block !important;
  z-index: 999999 !important;
}
</style>